export const scheduledEventMetadataByTenantLandscapeAndIdWithConnection = /* GraphQL */ `
  query ScheduledEventMetadataByTenantLandscapeAndId(
    $tenantLandscape: String
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelScheduledEventMetadataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scheduledEventMetadataByTenantLandscapeAndId(
      tenantLandscape: $tenantLandscape
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenant
        landscape
        tenantLandscape
        title
        description
        jobId
        job {
          id
          tenant
          landscape
          tenantLandscape
          jobCode
          title
          description
          jobTriggerFilePath
          hasOutputFile
          createdAt
          updatedAt
        }
        repeatType
        rruleSet
        holidayExecutionType
        useCustomHoliday
        customHolidayLabels
        eventTriggerType
        createdBy
        updatedBy
        editedAt
        expirationDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const scheduledEventMetadatasByTenantLandscapeWithConnection = /* GraphQL */ `
  query ScheduledEventMetadatasByTenantLandscape(
    $tenantLandscape: String
    $sortDirection: ModelSortDirection
    $filter: ModelScheduledEventMetadataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scheduledEventMetadatasByTenantLandscape(
      tenantLandscape: $tenantLandscape
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenant
        landscape
        tenantLandscape
        title
        description
        jobId
        job {
          id
          tenant
          landscape
          tenantLandscape
          jobCode
          title
          description
          jobTriggerFilePath
          hasOutputFile
          createdAt
          updatedAt
        }
        repeatType
        rruleSet
        holidayExecutionType
        useCustomHoliday
        customHolidayLabels
        eventTriggerType
        createdBy
        updatedBy
        editedAt
        expirationDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getScheduledEventMetadatas = /* GraphQL */ `
  query GetScheduledEventMetadatas(
    $tenantLandscape: String
    $nextToken: String
  ) {
    scheduledEventMetadatas: scheduledEventMetadatasByTenantLandscape(
      tenantLandscape: $tenantLandscape
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        rruleSet
        job {
          id
          title
          hasOutputFile
        }
      }
      nextToken
    }
  }
`;
